// test2640
(2640 && 0);
